import React, { useState } from "react";
import {
  FormControl,
  Button,
  ClickAwayListener,
  Fade,
  Radio,
  Grid,
  Paper,
  Popper,
  TextField,
  Typography,
  RadioGroup,
  FormLabel,
  FormControlLabel,
} from "@mui/material";
import Filter from "@mui/icons-material/FilterList";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "rgb(38, 118, 198)" },
  },
});

const regionStates = {
  COMESA: [
    "Comoros",
    "Democratic Republic of the Congo (DRC)",
    "Djibouti",
    "Egypt",
    "Eritrea",
    "Burundi",
    "Eswatini",
    "Ethiopia",
    "Kenya",
    "Libya",
    "Madagascar",
    "Malawi",
    "Mauritius",
    "Rwanda",
    "Seychelles",
    "Somalia",
    "South Sudan",
    "Sudan",
    "Zambia",
    "Zimbabwe",
    "Tanzania",
  ],
  EAC: ["Burundi", "Kenya", "Rwanda", "South Sudan", "Tanzania", "Uganda","Congo","Somalia"],
  IGAD: [
    "Djibouti",
    "Eritrea",
    "Ethiopia",
    "Kenya",
    "Somalia",
    "South Sudan",
    "Sudan",
    "Uganda",
  ],
  IOC: ["Comoros", "France (Réunion)", "Madagascar", "Mauritius", "Seychelles"],
  SADC: [
    "Angola",
    "Botswana",
    "Comoros",
    "Democratic Republic of the Congo (DRC)",
    "Eswatini",
    "Lesotho",
    "Madagascar",
    "Malawi",
    "Mozambique",
    "Namibia",
    "Seychelles",
    "South Africa",
    "Tanzania",
    "Zambia",
    "Zimbabwe",
    "Tanzania",
  ],
};

export default function ProjectFilter({
  status,
  setStatus,
  organization,
  setOrganization,
  country, // Add this prop
  setCountry,
  fundingType,
  setFundingType,
  setStartDate,
  setEndDate,
  handleClearFilters,
  fundingOptions,
}) {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const id = open ? "simple-popper" : undefined;

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Button
          style={{ margin: "8px 8px" }}
          aria-describedby={id}
          onClick={handleClick}
          variant="outlined"
          color="primary"
        >
          <span style={{ marginLeft: "8px" }}>Filters</span>
          <Filter />
        </Button>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          placement="bottom-start"
          transition
        >
          {({ TransitionProps }) => (
            <ClickAwayListener onClickAway={handleClickAway}>
              <Fade {...TransitionProps} timeout={350}>
                <Paper
                  style={{
                    padding: "16px",
                    width: "300px",
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    Filter by
                  </Typography>

                  <FormControl fullWidth margin="normal">
                    <FormLabel>Regional Network</FormLabel>
                    <RadioGroup
                      value={organization}
                      name="regionalNetwork"
                      onChange={(e) => setOrganization(e.target.value)}
                    >
                      <FormControlLabel value="All" control={<Radio />} label="All" />
                      {Object.keys(regionStates).map((network) => (
                        <FormControlLabel
                          key={network}
                          value={network}
                          control={<Radio />}
                          label={network}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                  <FormControl fullWidth margin="normal">
                    <FormLabel>Region Country</FormLabel>
                    <RadioGroup
                      value={country}
                      name="country"
                      onChange={(e) => setCountry(e.target.value)}
                    >
                      <FormControlLabel value="All" control={<Radio />} label="All" />
                      {organization !== "All" && regionStates[organization]?.map((item) => (
                        <FormControlLabel
                          key={item}
                          value={item}
                          control={<Radio />}
                          label={item}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                  <FormControl fullWidth margin="normal">
                    <FormLabel>Funding Type</FormLabel>
                    <RadioGroup
                      value={fundingType}
                      name="fundingType"
                      onChange={(e) => setFundingType(e.target.value)}
                    >
                      <FormControlLabel value="All" control={<Radio />} label="All" />
                      {fundingOptions.map((option) => (
                        <FormControlLabel
                          key={option}
                          value={option}
                          control={<Radio />}
                          label={option}
                        />
                      ))}
                    </RadioGroup>
                  </FormControl>
                  <FormControl fullWidth margin="normal">
                    <FormLabel id="demo-radio-buttons-group-label">
                      Status
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={status}
                      name="status"
                      style={{ marginBottom: "0 10px " }}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <FormControlLabel
                        value="All"
                        control={<Radio />}
                        label="All"
                      />
                      <FormControlLabel
                        value="Ongoing"
                        control={<Radio />}
                        label="Ongoing"
                      />
                      <FormControlLabel
                        value="Pending"
                        control={<Radio />}
                        label="Pending"
                      />
                      <FormControlLabel
                        value="Completed"
                        control={<Radio />}
                        label="Completed"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Start Date*"
                        type="date"
                        onChange={(e) => setStartDate(e.target.value)}
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="End Date*"
                        type="date"
                        onChange={(e) => setEndDate(e.target.value)}
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    style={{ marginTop: "16px" }}
                    onClick={() => {
                      handleClearFilters();
                      handleClickAway();
                    }}
                  >
                    Clear Filters
                  </Button>
                </Paper>
              </Fade>
            </ClickAwayListener>
          )}
        </Popper>
      </div>
    </ThemeProvider>
  );
}
